export default function MainNav(){
    return {
        activeItem: null,
        hamburger: false,
        isMobile: window.matchMedia('(max-width: 1024px)').matches,
        mobileOpen: false,
        init() {},
        mainNavItem: {
            ['x-on:mouseenter']($event) {
                return (!this.isMobile) ? this.activeItem = $event.currentTarget.dataset.which : null;
            },
            ['x-on:mouseleave']() {
                return (!this.isMobile) ? this.activeItem = '' : null;
            },
            ['x-on:click']($event) {
                return this.activeItem = $event.currentTarget.dataset.which;
            },
        },

        mobileAccordion: {
            ['x-on:click.prevent']($event) {
                // console.log($event.currentTarget.parentNode.dataset.which == this.activeItem)
                if($event.currentTarget.parentNode.dataset.which == this.activeItem)  {
                    this.activeItem = '';
                } else {
                    this.activeItem = $event.currentTarget.parentNode.dataset.which; 
                }
            }
        },

        mainMenu: {
            ['x-bind:class']() {
                return {
                    'MainNav-mobile': this.isMobile,
                    'is-active': this.mobileOpen && this.isMobile
                }
            }
        },

        hamburgerBtn: {
            ['x-on:click']() {
                this.hamburger = !this.hamburger;
                this.mobileOpen = !this.mobileOpen;
            }
        },

        isActive( which, type="main" ) {
            return (this.activeItem === which) && 'is-active';
        }
    }
}